import { useState, useCallback } from "react";
import axios from "axios";

const useUserFilters = () => {
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isLocalhost = window.location.hostname === "localhost";
  const baseUrl =
    window.location.origin + "/wp-json/bonusbank/v1/users-filters";

  const fetchFilters = useCallback(
    async (category, key) => {
      setLoading(true);
      try {
        let response;
        if (isLocalhost) {
          response = await axios.get(`/${category}-${key}.json`);
        } else {
          response = await axios.get(`${baseUrl}`, {
            params: { category, key },
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": window.nonce,
            },
          });
        }
        setFilters(response.data[0] || null);
        setError(null);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [isLocalhost, baseUrl]
  );

  const saveFilter = useCallback(
    async (filterData) => {
      setLoading(true);
      try {
        let response;
        if (isLocalhost) {
          // Simulate saving by updating the local state
          setFilters(filterData);
          response = { data: filterData };
        } else {
          response = await axios.post(`${baseUrl}/save`, filterData, {
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": window.nonce,
            },
          });
        }
        setError(null);
        return response.data;
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [isLocalhost, baseUrl]
  );

  const deleteFilter = useCallback(
    async (filterData) => {
      setLoading(true);
      try {
        if (isLocalhost) {
          // Simulate deleting by updating the local state
          setFilters(filterData);
        } else {
          await axios.post(`${baseUrl}/delete`, filterData, {
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": window.nonce,
            },
          });
        }
        setError(null);
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [isLocalhost, baseUrl]
  );

  return {
    filters,
    loading,
    error,
    fetchFilters,
    saveFilter,
    deleteFilter,
  };
};

export default useUserFilters;
